module.exports = __webpack_public_path__ + "img/lunar-flag.aab48d8c.svg";